import { VOneUrl } from "../url";

/*
The Url endpoints for the maintenance status.

Attributes:
    base: The base url.
    status: The url for the public maintenance status.
 */
export class MaintenanceUrl extends VOneUrl {
    public base: string;
    public status: string;

    constructor() {
        super();
        // Not under api/v1: this sits beside the health check.
        this.base = this.defineRoot();
        this.status = this.base + "app/maintenance";
    }
}
